<template>
  <div class="h-full">
    <div class="bottom_space rounded py-2 h-full bg-white">
      <div class="bottom_space flex justify-between p-2">
        <div v-if="IsSuperAdmin">
          <button class="list_top_card_btn bg-primary cta-text text-white py-3 px-5 rounded-3xl" @click="addComponent('0')">Create Component</button>
        </div>
      </div>
      <div>
      <div class="w-full" >
        <div class="progress-bar" v-if="searchLoader">
          <div class="progress-bar-value"></div>
        </div>
      </div>
      <div class="grid grid-cols-12">
        <div class="box col-span-7">
          <div style="overflow-y: auto; white-space: nowrap;" class="table_containder " v-if="!mobileView">
            <div class="text-text2  justify-between min-w-min heaer_row border border-gray1 font-bold flex heading-5 px-3 py-3 items-center">
              <div class="name_col flex items-center pl-4 ">
                <span class="cursor-pointer" @click="sortByColumn(0)">{{titleObj[0].title}} </span>
                <img v-if="titleObj[0].sortVal === 'DESC'" src="@/assets/images/svg/DESC.svg" /> 
                <img v-if="titleObj[0].sortVal === 'ASC'" src="@/assets/images/svg/ASC.svg" /> 
              </div>
              <div class="action_col flex items-center pl-4">
                <span class="cursor-pointer">{{titleObj[1].title}} </span>
              </div>
            </div>
            <div v-for="(data, index) in employeeList" :key="index" class="min-w-min group justify-between  flex border-r border-l border-b border-gray1  bg-white  text-sm px-3 py-2 items-center cursor-pointer hover:bg-gray-50">
              <div class="name_col pl-4" @click="showUserDetail(data)">
                <span class="heading-4  text-text2 font-medium">{{data.componentName}}</span>
              </div>
              <div class="action_col p-2 text-right">
                <p class="invisible group-hover:visible ">
                  <span class="px-1 pr-3 cursor-pointer" @click="addComponent(data.blogComponentMasterId)">
                    <i class="fas fa-edit text-primary h-5 w-5" ></i>
                  </span>
                  <!-- <span class="px-1 pr-3 cursor-pointer" >
                    <i class="fas fa-trash-alt text-error h-5 w-5" ></i>
                  </span> -->
                </p>
              </div>
            </div>
          </div>
          <div class="layout my-2" v-if="employeeList.length === 0">
            <div class="flex p-3 text-sm text-primary bg-blue-100 rounded-lg  items-center" role="alert">
              <svg aria-hidden="true" class="flex-shrink-0 inline w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
              <span class="sr-only">Info</span>
              <div>
                <p class=" font-medium heading-4">No record found.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-2">
      <Pagination
        :totalDataCount="totalEmpCount"
        :resetPagination="resetPaginationValues"
        @callApiAsPerPagination="getCustomerDataFromPagination"/>
    </div>
  </div>
  <div v-if="addComponentDialog" class="popup_overlay">
    <div class="bg-white rounded-sm p-4 custom_dialog" style="width:550px">
      <addComponent :componentMasterId="blogComponentMasterId"></addComponent>
    </div>
  </div>
</div>
</template>
<script>
import HRMAPI from '@/View/CMS/api/HRM.js'
import addComponent from '@/View/CMS/project/pages/blog/component/addComponent.vue'
// import Pagination from '@/View/components/pagination.vue'
import Pagination from '@/View/components/pagination.vue'
import {FilterPermissions} from '@/utils/Permissions.js'
import deboucneMixin from '@/mixins/debounce.js'
export default {
  components: {
    Pagination,
    addComponent
  },
  mixins: [deboucneMixin],
  data () {
    return {
      IsSuperAdmin: false,
      blogComponentMasterId: 0,
      userDetailValue: [],
      mobileView: false,
      addComponentDialog: false,
      istrue: true,
      userDetailId: 0,
      filterApplied: false,
      statusVal: true,
      navigationDialog: false,
      isFilterApplied: false,
      searchLoader: false,
      resetPaginationValues: false,
      showCustomerAddDialog: false,
      titleObj: [
        {title: 'Name', icon: 'fas fa-sort-amount-up', sortName: 'componentName', sortVal: 'DESC'},
        {title: 'Action', icon: '', sortName: '', sortVal: ''},
    ],
      cancelFilter: {
        selectedBranch: [],
        selectedDepartment: []
      },
      filterObject: {
        start: 0,
        length: 20,
        searchVal: '',
        sortBy: 'addedDate',
        sortOrder: 'DESC',
        isActive: true,
      },
      totalEmpCount: 0,
      paginationLength: 1,
      filterCol: 'text-gray-400',
      page: 1,
      items: [20, 25, 30, 50, 100],
      limitResData: 20,
      paginationData: 20,
      employeeList: [],
      canAdd: FilterPermissions('customer_account__add_new')
    }
  },
  created() {
    window.addEventListener("resize", this.resizeWindowHandler);
  },
  mounted () {
    // let Isadmin =  JSON.parse(localStorage.getItem('employeeData1'))
    // this.IsSuperAdmin = Isadmin.isSuperAdmin
    this.IsSuperAdmin = true
    this.resizeWindowHandler();
    document.title = 'Blog Component List'
    this.getContactListDeboucne = this.debounce(function () {
      this.resetPaginationValues = true
    }, 500)
    this.getComponentList()
    this.$root.$on("closeComponentDialog", (data) => {
      if (data === false) {
        this.addComponentDialog = false
        this.getComponentList()
      } else {
        this.addComponentDialog = false
      }
    });
  },
  watch: {
    titleObj: {
      handler () {
        console.log('titleObj 123', this.titleObj)
      }
    },
    filterApplied: {
      handler () {
        console.log('filterApplied 123', this.filterApplied)
        if (this.filterApplied === true) {
          this.filterCol = 'text-primary'
        } else {
          this.filterCol = 'text-success'
        }
      }
    },
    paginationData: {
      handler () {
        this.filterObject.length = this.paginationData
        this.showlistLoader = true
        this.getComponentList(this.showlistLoader)
      },
      deep: true
    }
  },
  methods: {
    resizeWindowHandler() {
      if (window.innerWidth < 684) {
        this.mobileView = true;
      } else {
        this.mobileView = false;
      }
    },
    showUserDetail (data) {
      console.log('data', data)
      this.$router.push({name: 'BlogComponentDetail', params: {projectId: data.projectDetailId, componentId: data.blogComponentMasterId}})
    },
    addComponent(data) {
      console.log(data)
      this.blogComponentMasterId = data
      this.addComponentDialog = true
    },
    customerSearch () {
      document.getElementById('custSearchInput').focus()
    },
    clearSearch () {
      this.searchLoader = false
      this.getComponentList()
    },
    getCustomerDataFromPagination (data) {
      this.filterObject.start = data.offset
      this.filterObject.length = data.limit
      let showlistLoader = false
      if (data.offset !== 0) {
        showlistLoader = true
      }
      this.getComponentList(showlistLoader)
    },
    sortByColumn (index) {
      for (let i = 0; i < this.titleObj.length; i++) {
        if (i === index) {
          if (this.titleObj[i].icon === '') {
            this.titleObj[i].icon = 'fas fa-sort-amount-down'
            this.titleObj[i].sortVal = 'DESC'
            this.filterObject.sortOrder = 'DESC'
          } else if (this.titleObj[i].icon === 'fas fa-sort-amount-down') {
            this.titleObj[i].icon = 'fas fa-sort-amount-up'
            this.titleObj[i].sortVal = 'ASC'
            this.filterObject.sortOrder = 'ASC'
          } else {
            this.titleObj[i].icon = 'fas fa-sort-amount-down'
            this.filterObject.sortOrder = 'DESC'
            this.titleObj[i].sortVal = 'DESC'
          }
        } else {
          this.titleObj[i].icon = ''
          this.titleObj[i].sortVal = ''
        }
      }
      this.filterObject.sortBy = this.titleObj[index].sortName
      this.getComponentList(true)
    },
    redirectToDetail (employeeId) {
      if (FilterPermissions('employee__detail_view')) {
        this.$router.push({name: 'EmployeeDetail', params: {employeeId: employeeId}})
      }
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    statusChip (val) {
      console.log(val)
      if (val === 'active') {
        this.statusVal = true
        this.filterObject.isActive = true
      } else if (val === 'inactive') {
        this.statusVal = false
        this.filterObject.isActive = false
      }
      this.getComponentList()
    },
    getLeaveDataAsPerPagination1 (data) {
      this.filterObject.length = data
      this.getComponentList()
    },
    getComponentList () {
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      HRMAPI.BlogComponentList(
        this.filterObject.start,
        this.filterObject.length,
        this.filterObject.searchVal,
        this.filterObject.sortBy,
        this.filterObject.sortOrder,
        this.filterObject.isActive,
        parseInt(this.$route.params.projectId),
        response => {
          console.log("response", response.Data)
          this.resetPaginationValues = false
          this.employeeList = response.Data.tableRow === null ? [] : response.Data.tableRow
          this.totalEmpCount = response.Data.count
          console.log('count', this.totalEmpCount)
          this.searchLoader = false
          this.$store.dispatch('SetLoader', {status: false, message: ''})
        },
        error => {
          this.$store.dispatch('SetLoader', {status: false, message: ''})
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
        }
      )
    }
  },
  beforeDestroy () {
    this.$root.$off('closeComponentDialog')
  }
}
</script>
<style scoped>
.table_containder {
  padding: 1px;
}
.name_col {
  min-width: 600px !important;
  width: 600px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.name_col {
  min-width: 600px !important;
  width: 600px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.action_col {
  min-width: 300px !important;
  width: 300px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
  justify-content: end;
}
.list_btn {
  min-width: 77px !important;
  max-width: 77px;
}
.select_btn {
  min-width: 77px !important;
  max-width: 77px;
}
.select_btn:focus-visible {
  outline: none;
}
.search_customer_box {
  min-width: 335px !important;
  max-width: 335px;
}
.list_top_card_btn {
  width: 183px !important;
  margin-right: 15px !important;
}
.row_user_svg {
  height: 36px;
  width: 36px;
}
.navbar-open {
  transform: translateX(0%);
}
.navbar-close {
  transform: translateX(-100%);
}
.demo-container {
  width: 300px;
  margin: auto;
}

.progress-bar {
  height: 2px;
  background-color: rgb(18,149,186);
  width: 100%;
  overflow: hidden;
}

.progress-bar-value {
  width: 100%;
  height: 100%;
  background-color: rgb(121, 200, 221);
  animation: indeterminateAnimation 2s infinite linear;
  transform-origin: 0% 50%;
}

@keyframes indeterminateAnimation {
  0% {
    transform:  translateX(0) scaleX(0);
  }
  40% {
    transform:  translateX(0) scaleX(0.4);
  }
  100% {
    transform:  translateX(100%) scaleX(0.5);
  }
}
::placeholder {
  font-size: 16px;
}
.lableWidth {
  width: 105px;
}
.dotwidth {
  width: 15px;
}
</style>
